export const getInventoryNameById = (inventories, inventoryId) => {
  var _inventories$find$nam, _inventories$find;
  return (_inventories$find$nam = (_inventories$find = inventories.find(({
    _id
  }) => _id === inventoryId)) === null || _inventories$find === void 0 ? void 0 : _inventories$find.name) !== null && _inventories$find$nam !== void 0 ? _inventories$find$nam : 'My Inventory';
};